<template lang="pug">
section
	div.hero-body
		div.container
			div.columns.is-centered
				div.column.is-four-fifths
					router-view
	div.hero-foot.has-text-centered
		div.logo
</template>

<script>
export default {
	name: "FullPageRegistration",
	created() {
		this.$store.commit("fullPage", true);
		this.$store.commit("asideRightToggle", false);
	},
	beforeDestroy() {
		this.$store.commit("fullPage", false);
	}
};
</script>


<style lang="scss" scoped>
@import "../scss/mixins";

.hero-body {
	@include respond-below(xs) {
		padding: 1.5rem 0.5rem;
	}

	.container {
		::v-deep .columns {}
	}
}
</style>
